export const grid = {
  maxWidth: {
    default: '90%',
    desktop: '1700px',
  },
};
